import { useQuery } from '@tanstack/react-query';
import { getApiV1Delft3dOrchestrationsByOrchestrationIdSimulationProgress } from '../api/generated/sdk.gen';
import { useAccessToken } from '../auth/AccessTokenContext';
import { queryKeys } from './queryKeys';

export const useFetchOrchestrationProgress = (
  orchestrationId: string | null | undefined,
  shouldPoll = false,
) => {
  const token = useAccessToken();

  return useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: queryKeys.orchestrationProgress(orchestrationId as string),
    queryFn: async () => {
      if (!orchestrationId) return null;

      const response =
        await getApiV1Delft3dOrchestrationsByOrchestrationIdSimulationProgress({
          path: {
            orchestrationId,
          },
        });
      return response.data?.data || null;
    },
    // Only fetch when actively polling (Simulation phase).
    // Completed orchestrations use orchestration.simulation_progress summary.
    enabled: !!token && !!orchestrationId && shouldPoll,
    refetchInterval: shouldPoll ? 10000 : false,
  });
};
